import { render, staticRenderFns } from "./FloatingAssistant.vue?vue&type=template&id=7b6aae50&scoped=true"
import script from "./FloatingAssistant.vue?vue&type=script&lang=js"
export * from "./FloatingAssistant.vue?vue&type=script&lang=js"
import style0 from "./FloatingAssistant.vue?vue&type=style&index=0&id=7b6aae50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6aae50",
  null
  
)

export default component.exports
import {QHeader} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader})
